import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import getPremium from 'core/controllerPlans/getPremium'
import moneyFormat from 'utils/format/money'
import innerHTML from 'utils/DOM/innerHTML'
import getById from 'utils/DOM/getById'
import store from 'utils/store/withMiddleware'
import { propAccessor } from '@hc-frontend/utils'

function getDescription(obj) {
  return obj ? obj.description : undefined
}

function handleOpenModalLatitude(e) {
  e.preventDefault()
  const state = store.getState()
  const planId = +this.getAttribute('data-id')
  const contextPlanId = +this.getAttribute('data-planId')
  const plan = state.plans[planId]
  const brochureId = plan.brochureId

  const latitudeAddonByContextPlan = propAccessor(
    state.latitudeAddons,
    String(contextPlanId),
    undefined
  )

  fetchJSONHandleError({ url: state.jsons[plan.jsonId] }).then(details => {
    const templateModal = Templater(getById('template-latitude-modal').innerText)
    const hasRoadside = details.benefits[0].body[3]?.title === 'Roadside Reimbursement'

    const doctorParagraph = details.benefits[0].body[0].description.slice(0, 4)
    const doctorBullets = details.benefits[0].body[0].description.slice(4)

    const doctorSectionString =
      doctorParagraph.join(' ') + '<br/><br/>' + doctorBullets.join('<br/><br/>')

    innerHTML(
      '#addOnModal .modal-body',
      templateModal({
        planName: plan.planName,
        planId: plan.planId,
        premium: moneyFormat(getPremium(plan)),
        insuranceBenefits: details.insuranceBenefits,
        remove: planId === state.latitudeId || planId === latitudeAddonByContextPlan,
        doctorSection: doctorSectionString,
        prescriptionSection: getDescription(details.benefits[0].body[1]),
        visionSection: getDescription(details.benefits[0].body[2]),
        roadSide: hasRoadside ? getDescription(details.benefits[0].body[3]) : undefined,
        additionalBenefits: hasRoadside
          ? getDescription(details.benefits[0].body[4])?.join('<br/><br/>')
          : getDescription(details.benefits[0].body[3])?.join('<br/><br/>'),
        brochureLink: state.brochures[brochureId],
        contextPlanId
      })
    )
    $('#addOnModal').modal('show')
  })
}

export default handleOpenModalLatitude
